module.exports = __webpack_public_path__ + "img/logo-icon.0843afa9.svg";